"use client";

import {
  createContext,
  type ReactNode,
  useCallback,
  useContext,
  useState,
} from "react";

interface InvitesCacheContextValue {
  invitesCacheKey: number;
  invalidateInvitesCache: () => void;
}

const InvitesCacheContext = createContext<InvitesCacheContextValue | null>(
  null,
);

export function InvitesCacheProvider({ children }: { children: ReactNode }) {
  const [invitesCacheKey, setInvitesCacheKey] = useState(() => Date.now());

  const invalidateInvitesCache = useCallback(() => {
    setInvitesCacheKey(Date.now());
  }, []);

  return (
    <InvitesCacheContext.Provider
      value={{ invitesCacheKey, invalidateInvitesCache }}
    >
      {children}
    </InvitesCacheContext.Provider>
  );
}

export function useInvitesCacheKey(): InvitesCacheContextValue {
  const context = useContext(InvitesCacheContext);
  if (!context) {
    throw new Error(
      "useInvitesCacheKey must be used within InvitesCacheProvider",
    );
  }
  return context;
}
